module.exports = __webpack_public_path__ + "img/icon_map_36_off_111.0f564381.png";